module.exports = __webpack_public_path__ + "static/media/116.b6690338.jpg";